import { EnrolmentStatusActionTypes, IEnrolmentStatusState } from './types';
import { StudentActionTypes } from '../types';
import { Reducer } from 'redux';

const initialState: IEnrolmentStatusState = {
  travelStatusSection: {},
  accommodationStatusSection: {},
};

export const enrolmentStatusReducer: Reducer<IEnrolmentStatusState> = (state = initialState, action) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS: {
      return {
        ...initialState,
        ...action.payload.student.enrolmentStatus,
      };
    }
    case EnrolmentStatusActionTypes.UPDATE_ARRIVAL_STATUS: {
      return {
        ...state,
        travelStatusSection: {
          ...state.travelStatusSection,
          ...action.payload,
        },
      };
    }
    default: {
      return state;
    }
  }
};
